import createActionTypes from 'shared/app/state/create-action-types';

export const {
  // Sign In
  SIGNAL_SIGN_IN,
  SIGNAL_SIGN_IN_ERROR,
  SIGNAL_SIGN_IN_SUCCESS,

  // Reset forgotten password
  RESET_FORGOT_PASSWORD,
  RESET_FORGOT_PASSWORD_ERROR,
  RESET_FORGOT_PASSWORD_SUCCESS,

  // Mfa token
  VERIFY_MFA_ACCESS,
  VERIFY_MFA_ACCESS_ERROR,
  VERIFY_MFA_ACCESS_SUCCESS,
} = createActionTypes([
  // Sign In
  'SIGNAL_SIGN_IN',
  'RESET_FORGOT_PASSWORD',
  'VERIFY_MFA_ACCESS',
]);
